import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Card, PageHeader, Pill } from "../../components/UI";
import { LayoutTemplate, Trash2 } from "lucide-react";

export default function LandingPages() {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const load = async () => { const { data } = await api.get("/fundraising/landing-pages"); setPages(data); };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/fundraising/landing-pages/${id}`); load();
  };

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader
        eyebrow="Fundraising"
        title="Landing Pages"
        subtitle="AI-generated fundraising landing pages ready to publish or embed."
      />
      {pages.length === 0 ? (
        <Card>
          <div className="text-center py-10">
            <LayoutTemplate className="w-10 h-10 mx-auto text-slate-600" />
            <div className="mt-3 font-display text-lg font-semibold">No landing pages yet</div>
            <p className="text-sm text-slate-500 mt-1">Head to the AI Landing Page Builder to generate one from a prompt.</p>
          </div>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pages.map(p => (
            <Card key={p.id}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-display text-lg font-bold">{p.name}</div>
                  <div className="text-xs text-slate-400 mt-1 line-clamp-2">{p.prompt}</div>
                </div>
                <Pill status="Draft">Draft</Pill>
              </div>
              <div className="mt-3 text-[10px] text-slate-500">
                {p.blocks?.length || 0} blocks · {new Date(p.created_at).toLocaleDateString()}
              </div>
              <div className="mt-3 flex justify-end">
                <button onClick={() => del(p.id)} className="text-slate-500 hover:text-rose-300 p-1"><Trash2 className="w-4 h-4" /></button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
